import {GeoAppEvents} from "../../controllers/events/geoapp_events";
import {L} from "../../lt-ng/landcare-toolkit";
import getUserSelectableLayers = L.tree.getUserSelectableLayers;
import forEachNode = L.tree.forEachNode;
import Item = L.tree.Item;
import {LTServices} from "../../lt-ng/lt-services";
import IMapService = LTServices.IMapService;
import {delay} from "../commands";
import {ILayerTreeManipulationService} from "../../services/oe/layer-tree-manipulation";

export function resetMap($rootScope: ng.IRootScopeService, mapService: IMapService, layerTreeManipulationService: ILayerTreeManipulationService) {
    const layers = getUserSelectableLayers(mapService.treeData);

    forEachNode(layers, (node: Item) => {
        node.extraState.metaLayerSelector.checked = false;
        node.extraState.metaLayerSelector.expanded = false;
    });

    $rootScope.$broadcast('onTreeChange');
    $rootScope.$broadcast(GeoAppEvents.resetMapAndLayers);
}

export function typeIntoInput(inputElement: HTMLInputElement, textToType: string): Promise<void> {
    const charactersToType = textToType.split('');

    inputElement.click();
    inputElement.focus();
    let typedText = '';

    return charactersToType.reduce((promise, key) => {
        return promise.then(() => {
            typedText += key;
            inputElement.value = typedText;
            inputElement.dispatchEvent(new KeyboardEvent('keydown', { key, bubbles: true, cancelable: true }));
            inputElement.dispatchEvent(new KeyboardEvent('keyup', { key, bubbles: true, cancelable: true }));
        }).then(() => delay(20))
    }, Promise.resolve())
}